import {
    request
} from '@/util/components/request'
import ctrl from '@/common/controller'

export const getMenus = async (role, stationId) => {
    let res = await request(ctrl.admin_role.get, {
        status: stationId,
        page: 1,
        limit: 9999
    })
    return res.data.data.find((s) => s.id === role).url
}
